import {
  NAVIGATION_DISABLE, NAVIGATION_ENABLE,
} from '../constants/navigation.constants';

export const enableNavigationAction = () => ({
  type: NAVIGATION_ENABLE,
});

export const disableNavigationAction = () => ({
  type: NAVIGATION_DISABLE,
});
